import {
  BellOutlined,
  FileSearchOutlined,
  FileTextOutlined,
  PlayCircleOutlined,
  SettingOutlined,
  SwapOutlined,
} from "@ant-design/icons";
import type { textMap } from "../../../i18n";
import "../../../styles/studio-scan-records.css";

type T = (typeof textMap)["en"];

type Props = {
  t: T;
  onRunFirstScan: () => void;
  onConfigureAlerts: () => void;
  onCompareFromEmpty: () => void;
};

export function ScanHistoryEmptyStatus({
  t,
  onRunFirstScan,
  onConfigureAlerts,
  onCompareFromEmpty,
}: Props) {
  return (
    <div className="she-root">
      <div className="she-grid">
        <div className="she-card-main">
          <div className="she-icon-cluster">
            <div className="she-icon-lg">
              <FileTextOutlined />
            </div>
            <div className="she-icon-sm">
              <FileSearchOutlined />
            </div>
          </div>
          <h2 className="she-title">{t.sheNoScansTitle}</h2>
          <p className="she-lead">
            {t.sheNoScansLead}
            {t.sheNoScansLeadSub ? (
              <span className="she-lead-sub">{t.sheNoScansLeadSub}</span>
            ) : null}
          </p>
          <button type="button" className="she-cta" onClick={onRunFirstScan}>
            <PlayCircleOutlined style={{ fontSize: 20 }} />
            {t.sheRunFirstScan}
          </button>
        </div>

        <div className="she-card-side">
          <div className="she-side-head">
            <span className="she-badge">{t.sheCompareBadge}</span>
            <SwapOutlined style={{ fontSize: 22, color: "#94a3b8" }} />
          </div>
          <div className="she-dashed-row">
            <div className="she-dashed-box" />
            <div className="she-dashed-box" />
          </div>
          <h3 className="she-side-title">{t.sheCompareTitle}</h3>
          <p className="she-side-desc">
            {t.sheCompareDesc}
            {t.sheCompareDescSub ? (
              <span className="she-side-desc-sub">{t.sheCompareDescSub}</span>
            ) : null}
          </p>
          <button type="button" className="she-side-btn" onClick={onCompareFromEmpty}>
            <SwapOutlined />
            {t.sheSelectHistory}
          </button>
        </div>

        <div className="she-card-wide">
          <div className="she-alert-icon">
            <BellOutlined />
          </div>
          <div className="she-alert-body">
            <div className="she-alert-title-row">
              <h3 className="she-alert-title">{t.sheAlertsTitle}</h3>
              <span className="she-dot" aria-hidden />
            </div>
            <p className="she-alert-desc">
              {t.sheAlertsDesc}
              {t.sheAlertsDescSub ? (
                <span className="she-alert-desc-sub">{t.sheAlertsDescSub}</span>
              ) : null}
            </p>
          </div>
          <button
            type="button"
            className="she-alert-cta"
            onClick={onConfigureAlerts}
          >
            <SettingOutlined />
            {t.sheConfigureAlerts}
          </button>
        </div>
      </div>
    </div>
  );
}
